import TronWeb from 'tronweb';
import { READ_API, USDT_TOKEN_ADDRESS } from './config';

const node = new TronWeb.providers.HttpProvider(READ_API);
const tronwebDefault = new TronWeb(node, node, node);
tronwebDefault.setAddress(USDT_TOKEN_ADDRESS);

export default tronwebDefault;